import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=4fdc39de&"
import script from "./change-password.vue?vue&type=script&lang=js&"
export * from "./change-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fdc39de')) {
      api.createRecord('4fdc39de', component.options)
    } else {
      api.reload('4fdc39de', component.options)
    }
    module.hot.accept("./change-password.vue?vue&type=template&id=4fdc39de&", function () {
      api.rerender('4fdc39de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/pages/change-password.vue"
export default component.exports